import { connect } from "react-redux";

import ConfirmComponent from "./Confirm";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(ConfirmComponent);
